import { render, staticRenderFns } from "./PosView.vue?vue&type=template&id=3c0e74db&scoped=true&"
import script from "./PosView.vue?vue&type=script&lang=js&"
export * from "./PosView.vue?vue&type=script&lang=js&"
import style0 from "./PosView.vue?vue&type=style&index=0&id=3c0e74db&scoped=true&lang=css&"
import style1 from "./PosView.vue?vue&type=style&index=1&id=3c0e74db&scoped=true&lang=css&"
import style2 from "./PosView.vue?vue&type=style&index=2&id=3c0e74db&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0e74db",
  null
  
)

export default component.exports